import { GrowlContextType } from '../../types/Growl';

export class GrowlThunk {
  private growlContext: GrowlContextType | null = null;

  set(growl: GrowlContextType) {
    this.growlContext = growl;
  }

  showSuccess(messageKey?: string, fade?: boolean) {
    return this.growlContext?.showSuccess(messageKey, fade);
  }

  showError(error?: any) {
    return this.growlContext?.showError(error);
  }
}
